let resourcePluralizer = new Map();

resourcePluralizer.set("college", "colleges");
resourcePluralizer.set("club", "clubs");
resourcePluralizer.set("user", "users");
resourcePluralizer.set("state", "states");
resourcePluralizer.set("collegeGpa", "collegeGpas");
resourcePluralizer.set("academicSpeciality", "academicSpecialities");
resourcePluralizer.set("division", "divisions");
resourcePluralizer.set("collegeState", "collegeStates");
resourcePluralizer.set("schoolType", "schoolTypes");
resourcePluralizer.set("educationType", "educationTypes");
resourcePluralizer.set("collegeSetting", "collegeSettings");
resourcePluralizer.set("ageGroup", "ageGroups");
resourcePluralizer.set("favourite", "favourites");
resourcePluralizer.set("playerPosition", "playerPositions");
resourcePluralizer.set("playerState", "playerStates");
resourcePluralizer.set("athlete", "athletes");
resourcePluralizer.set("throwingHand", "throwingHands");
resourcePluralizer.set("battingHand", "battingHands");
resourcePluralizer.set("clubEventType", "clubEventTypes");
resourcePluralizer.set("collegeEventType", "collegeEventTypes");
resourcePluralizer.set("clubEvent", "clubEvents");
resourcePluralizer.set("collegeEvent", "collegeEvents");
resourcePluralizer.set("collegeEventList", "collegeEvents");
resourcePluralizer.set("playerEvent", "events");
resourcePluralizer.set("college_event", "collegeEvents");
resourcePluralizer.set("club_event", "clubEvents");
resourcePluralizer.set("fav", "favourites");
resourcePluralizer.set("coach", "coaches");
resourcePluralizer.set("news", "news");
resourcePluralizer.set("roster", "rosters");
resourcePluralizer.set("conversation", "conversations");
resourcePluralizer.set("message", "messages");
resourcePluralizer.set("misc", "misc");
resourcePluralizer.set("country", "countries");

export default resourcePluralizer;
